import {
  targetGroupsByPhysicalConstants,
  createTargetGroupsByPhysicalConstants,
  editTargetGroupsByPhysicalConstants,
  deleteTargetGroupsByPhysicalConstants,
} from "../_redux-constants";

export function targetGroupsPhysicalReducer(
  state = {
    targetGroupsByPhysicalLoading: false,
    targetGroupsByPhysicalData: null,
    targetGroupsByPhysicalError: null,

    createTargetGroupsByPhysicalLoading: false,
    createTargetGroupsByPhysicalData: null,
    createTargetGroupsByPhysicalError: null,

    editTargetGroupsByPhysicalLoading: false,
    editTargetGroupsByPhysicalData: null,
    editTargetGroupsByPhysicalError: null,

    addTargetGroupsByPhysicalLoading: false,
    addTargetGroupsByPhysicalData: null,
    addTargetGroupsByPhysicalError: null,

    removeTargetGroupsByPhysicalLoading: false,
    removeTargetGroupsByPhysicalData: null,
    removeTargetGroupsByPhysicalError: null,

    deleteTargetGroupsByPhysicalLoading: false,
    deleteTargetGroupsByPhysicalData: null,
    deleteTargetGroupsByPhysicalError: null,
  },
  action
) {
  switch (action.type) {
    case targetGroupsByPhysicalConstants.TARGET_GROUPS_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        targetGroupsByPhysicalLoading: true,
        targetGroupsByPhysicalData: null,
        targetGroupsByPhysicalError: null,
      });
    case targetGroupsByPhysicalConstants.TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsByPhysicalLoading: false,
        targetGroupsByPhysicalData: action.data,
      });
    case targetGroupsByPhysicalConstants.TARGET_GROUPS_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        targetGroupsByPhysicalLoading: false,
        targetGroupsByPhysicalData: null,
        targetGroupsByPhysicalError: action.error,
      });
    case createTargetGroupsByPhysicalConstants.CREATE_TARGET_GROUPS_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        createTargetGroupsByPhysicalLoading: true,
        createTargetGroupsByPhysicalData: null,
        createTargetGroupsByPhysicalError: null,
      });
    case createTargetGroupsByPhysicalConstants.CREATE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        createTargetGroupsByPhysicalLoading: false,
        createTargetGroupsByPhysicalData: action.data,
      });
    case createTargetGroupsByPhysicalConstants.CREATE_TARGET_GROUPS_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        createTargetGroupsByPhysicalLoading: false,
        createTargetGroupsByPhysicalData: null,
        createTargetGroupsByPhysicalError: action.error,
      });
    case editTargetGroupsByPhysicalConstants.EDIT_TARGET_GROUPS_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        editTargetGroupsByPhysicalLoading: true,
        editTargetGroupsByPhysicalData: null,
        editTargetGroupsByPhysicalError: null,
      });
    case editTargetGroupsByPhysicalConstants.EDIT_TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        editTargetGroupsByPhysicalLoading: false,
        editTargetGroupsByPhysicalData: action.data,
      });
    case editTargetGroupsByPhysicalConstants.EDIT_TARGET_GROUPS_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        editTargetGroupsByPhysicalLoading: false,
        editTargetGroupsByPhysicalData: null,
        editTargetGroupsByPhysicalError: action.error,
      });

    case deleteTargetGroupsByPhysicalConstants.DELETE_TARGET_GROUPS_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        deleteTargetGroupsByPhysicalLoading: true,
        deleteTargetGroupsByPhysicalData: null,
        deleteTargetGroupsByPhysicalError: null,
      });
    case deleteTargetGroupsByPhysicalConstants.DELETE_TARGET_GROUPS_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        deleteTargetGroupsByPhysicalLoading: false,
        deleteTargetGroupsByPhysicalData: action.data,
      });
    case deleteTargetGroupsByPhysicalConstants.DELETE_TARGET_GROUPS_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        deleteTargetGroupsByPhysicalLoading: false,
        deleteTargetGroupsByPhysicalData: null,
        deleteTargetGroupsByPhysicalError: action.error,
      });
    default:
      return state;
  }
}
